const info = require('../resource/info')
const settings = require('../settings')
const Model = require('./model')

const calculateQuote = ({
  folderId = 'root',
  items,
  children,
  expanded = {},
  mergeMarkups = false,
  mergeAdjustments = false,
  markups = {},
  vat = 0,
  preRounding = false,
  ignoreRates = false,
}) => {
  
  // keep track of markup totals based on the type of resource
  const markupPrices = {}
  const priceMarkups = mergeMarkups ? markups : null

  const addMarkupTotal = ({
    type,
    price,
  }) => {
    // if we are merging the markups then we don't add them here
    if(mergeMarkups) return
    if(info.markupIgnore(type)) return
    const useType = info.markupType(type)
    markupPrices[useType] = (markupPrices[useType] || 0) + price
  }

  const model = Model({
    items,
    children,
    expanded,
    preRounding,
    ignoreRates,
    mergeAdjustments,
    markups: priceMarkups,
    onAddMarkup: addMarkupTotal,
  })
  
  const rootChildren = model.getItemChildren({
    parentId: folderId
  })

  const rows = rootChildren.reduce((all, item, i) => {
    return all.concat(model.getItemContents({
      item,
      depth: 0,
      index: i,
    }))
  }, [])

  const costsTotal = rows
    .filter(row => row.depth == 0)
    .reduce((total, row) => {
      return total + row.price.price
    }, 0)

  const markupTotals = settings.markupOrder.reduce((all, type) => {
    const price = markupPrices[type] || 0
    const rate = markups[type] || 0
    const total = price * (rate / 100)
    const markup = {
      type,
      price,
      rate,
      total,
    }
    all[type] = markup
    return all
  }, {})

  const markupTotal = Object.keys(markupTotals)
    .reduce((total, type) => {
      return total + markupTotals[type].total
    }, 0)

  const subTotal = costsTotal + markupTotal
  const vatAmount = (vat / 100) * subTotal
  const grandTotal = subTotal + vatAmount

  return {
    rows,
    markups: markupTotals,
    totals: {
      costsTotal,
      markupTotal,
      subTotal,
      vatAmount,
      grandTotal
    }
  }
}

module.exports = calculateQuote
